
    <div mat-dialog-title style=" display: flex; justify-content: space-between;align-items: center;">
      <span>Import Apps</span>
      <mat-icon [matTooltip]="data.schema">info</mat-icon>
    </div>
    <div mat-dialog-content>
      <form #f="ngForm" class="d-flex flex-column">
        <cm-upload-button *ngIf="!editMode" (fileSelected)="this.file = $event"
                          (fileCanceled)="this.file = null"></cm-upload-button>

      </form>

    </div>
    <div mat-dialog-actions class="justify-content-center">
      <button mat-raised-button color="" class="mr-1" [mat-dialog-close]="false">Close</button>
      <button mat-raised-button class="iconed" color="primary" [disabled]="!editMode && !file" (click)="save()">
        <i class="fas fa-save"></i>
        <span>Save</span>
      </button>
    </div>
  